export const ApiErrors = {
  CPF_ALREADY_IN_USE: 'CPF_ALREADY_IN_USE',
  INVALID_LOGIN: 'INVALID_LOGIN',
  EMAIL_ALREADY_IN_USE: 'EMAIL_ALREADY_IN_USE',
  INVALID_COUPON: 'INVALID_COUPON',
}
